import { FuseAnimate } from "@fuse";
import { Card, CardContent, Icon, Typography, withStyles } from "@material-ui/core";
import * as Helpers from "app/Core/Helpers";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";

const styles = theme => ({
    root: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.primary.contrastText
    },
});

function ConfirmacaoEmailPage({ classes, location }) {
    return (
        <React.Fragment>
            <div className={clsx(classes.root, "flex flex-col flex-auto flex-shrink-0 items-center justify-center p-32")}>

                <div className="flex flex-col items-center justify-center w-full">

                    <FuseAnimate animation="transition.expandIn">

                        <Card className="w-full max-w-384">

                            <CardContent className="flex flex-col items-center justify-center p-32">

                                <div className="m-32">
                                    <Icon className="text-96" color="action">email</Icon>
                                </div>

                                <Typography variant="h5" className="text-center mb-16">Confirmar email!</Typography>

                                <Typography className="text-center mb-16 w-full" color="textSecondary">
                                    Um email de confirmação foi enviado para <b>{Helpers.ReplaceAll(location.search, "?q=", "")}</b>.
                                </Typography>

                                <Typography className="text-center w-full" color="textSecondary">
                                    {"Verifique sua caixa de entrada e clique no link \"Confirmar meu email\" para confirmar seu endereço de email."}
                                </Typography>

                                <div className="flex flex-col items-center justify-center pt-32 pb-24">
                                    <Link id="link-login" className="font-medium" to="/pub-login">Fazer login em vez disso</Link>
                                </div>

                            </CardContent>
                        </Card>
                    </FuseAnimate>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withStyles(styles)(ConfirmacaoEmailPage);
